// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"maincontent_mainContent__2QnK9","rotated":"maincontent_rotated__3QJ0B","page":"maincontent_page__2Z9Sg"};